// extracted by mini-css-extract-plugin
export default {"RhtFormSec":"RightSection_RhtFormSec__rZ3Ro","inputBox":"RightSection_inputBox__7vsTr"};